<template>
  <div>
    <vx-card heading-size="h1" title="Welcome">
      <p>Welcome to the Virtual Job Experience teacher area {{ name }},</p>
      <vs-divider />
      <p class="mb-5">In your teacher account you can:</p>

      <ul class="default-list">
        <li>manage the whole Virtual Job Experience program for your school</li>
        <li>view student experiences/responses/activities</li>
        <li>issue certificates to students</li>
      </ul>
      <br />
      <p>It is designed to be extremely flexible for both you and your students.</p>
    </vx-card>
  </div>
</template>

<script>
import store from '@/store/store';

export default {
  computed: {
    fname() {
      return store.getters['authTeacher/fName'];
    },
  },
  data() {
    return {
      name: this.fname,
    };
  },
  watch: {
    fname() {
      this.name = this.fname;
    },
  },
  mounted() {
    this.name = this.fname;
  },
};
</script>
